import React from 'react';
import { MultiSelect, Select, Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { formatStoreLabel, getStoresForVirtualAssignment } from './helpers';
import { SapDivisionOption, VirtualDivisionFormValues } from './types';

type Props = {
    form: UseFormReturnType<VirtualDivisionFormValues>;
    sapDivisions: SapDivisionOption[];
    occupiedStoreIds: Set<string>;
};

export function VirtualHierarchyStoresStep({
    form,
    sapDivisions,
    occupiedStoreIds,
}: Props) {
    const divisionOptions = sapDivisions.map(division => ({
        value: division.id,
        label: division.name,
    }));
    const availableStores = getStoresForVirtualAssignment(
        sapDivisions,
        form.values.sourceDivisionId,
        form.values.storeIds,
    );
    const storeOptions = availableStores.map(store => ({
        value: store.id,
        label: formatStoreLabel(store),
        disabled: occupiedStoreIds.has(store.id),
    }));

    return (
        <Stack gap="sm">
            <Text size="sm" c="dimmed">
                Pick stores from any SAP division. Use the filter to narrow the
                list. A store can only have one virtual home.
            </Text>
            <Select
                label="SAP division filter"
                placeholder="All SAP divisions"
                searchable
                clearable
                data={divisionOptions}
                value={form.values.sourceDivisionId || null}
                onChange={value =>
                    form.setFieldValue('sourceDivisionId', value ?? '')
                }
                error={form.errors.sourceDivisionId}
            />
            <MultiSelect
                label="Stores"
                placeholder="Select stores"
                searchable
                data={storeOptions}
                {...form.getInputProps('storeIds')}
            />
        </Stack>
    );
}
